var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pin-share-page"},[_c('PHeader'),_c('Pins',{attrs:{"pin-filters":_vm.filters,"single-pin-view":true,"auto-open-preview":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }